import LogRocket from 'logrocket';
import LogrocketFuzzySanitizer from 'logrocket-fuzzy-search-sanitizer';

// src/init.ts
var defaultPrivateFieldNames = [
  "email",
  "personalEmail",
  "phoneNumber",
  "password",
  "firstName",
  "lastName",
  "givenName",
  "fullName",
  "gender",
  "timeZone",
  "birthday"
];
var defaultPrivateQueryParameterNames = [
  "token",
  "email",
  "password"
];
var generateUrlSanitizationMethod = (queryParametersToSanitize) => {
  return (url) => {
    let sanitizedUrl = url;
    for (const queryParam of queryParametersToSanitize) {
      sanitizedUrl = sanitizedUrl.replace(new RegExp(`${queryParam}=([^&]*)`, "i"), `${queryParam}=**redacted**`);
    }
    return sanitizedUrl;
  };
};
var init = (appId, options = {}) => {
  LogRocket.init(appId, buildLogRocketOptions(options));
};
var buildLogRocketOptions = (options = {}) => {
  const { requestSanitizer, responseSanitizer } = LogrocketFuzzySanitizer.setup(options.privateFieldNames ?? defaultPrivateFieldNames);
  return {
    rootHostname: "workleap.com",
    ...options,
    dom: {
      textSanitizer: true,
      inputSanitizer: true,
      ...options.dom
    },
    network: {
      requestSanitizer: (req) => {
        if (options.network?.requestSanitizer) {
          return options.network.requestSanitizer(req);
        }
        if (req.headers["Authorization"]) {
          req.headers["Authorization"] = "**redacted**";
        }
        if (req.body) {
          req.body = "**redacted**";
        }
        return requestSanitizer(req);
      },
      responseSanitizer: (res) => {
        if (options.network?.responseSanitizer) {
          return options.network.responseSanitizer(res);
        }
        if (res.body) {
          res.body = "**redacted**";
        }
        return responseSanitizer(res);
      },
      ...options.network
    },
    browser: {
      urlSanitizer: generateUrlSanitizationMethod(options.privateQueryParameterNames ?? defaultPrivateQueryParameterNames),
      ...options.browser
    }
  };
};

export { buildLogRocketOptions, generateUrlSanitizationMethod, init };
